import TransactionClickModal from './TransactionClickModal'
import TransactionMapHover from './TransactionMapHover'
import TransactionController from './TransactionController'

export const TransactionMapConfig = {
  Click: TransactionClickModal,
  Hover: TransactionMapHover,
  Controller: TransactionController,
}
